export const DOCUMENT_TEMPLATE_DOC_TYPES = [
    "rateConfirmation",
    "billOfLading",
    "packingList",
    "palletLabel",
] as const

export type DocumentTemplateDocType =
    (typeof DOCUMENT_TEMPLATE_DOC_TYPES)[number]

export const CSV_EXPORT_DOC_TYPE = "csvExport" as const

export const XLSX_EXPORT_DOC_TYPE = "xlsxExport" as const

export const GENERATE_DOCUMENT_DOC_TYPES = [
    ...DOCUMENT_TEMPLATE_DOC_TYPES,
    CSV_EXPORT_DOC_TYPE,
    XLSX_EXPORT_DOC_TYPE,
] as const

export type GenerateDocumentDocType =
    (typeof GENERATE_DOCUMENT_DOC_TYPES)[number]

export const DOCUMENT_TEMPLATE_KINDS = ["pdf", "email"] as const
export type DocumentTemplateKind = (typeof DOCUMENT_TEMPLATE_KINDS)[number]

export const DOCUMENT_TEMPLATE_MAPPING_MODES = ["replace", "patch"] as const
export type DocumentTemplateMappingMode =
    (typeof DOCUMENT_TEMPLATE_MAPPING_MODES)[number]
